/*
 * Copyright (c) 2023 JCA Electronics , Winnipeg, MB. All rights reserved.
 */
export enum MachineCertificateStatus {
  None, //No certificate difined
  Active, //Current Certificate is active
  Revoked //Current certificate is revoked
}

export interface MachineCredential {
  MachineId: string;
  AccountId: string;
  MachineName: string;
  CertificateStatus: MachineCertificateStatus;
  DeployedTimeUTC: Date;
  UpdateTimeUTC: Date;
}

// Converts JSON strings to/from your types
export class Convert {
  public static toModel(json: string): MachineCredential {
    return JSON.parse(json);
  }

  public static toModelCollection(json: string): MachineCredential[] {
    return JSON.parse(json);
  }
}
